import { render } from "./ChooseAccountTypeModal.vue?vue&type=template&id=71f0e05c&ts=true"
import script from "./ChooseAccountTypeModal.vue?vue&type=script&lang=ts"
export * from "./ChooseAccountTypeModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__